import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Shell } from './components/layout/Shell';
import { Dashboard } from './pages/Dashboard';
import { NewProject } from './pages/NewProject';
import { OpenProject } from './pages/OpenProject';
import { SharedView } from './pages/SharedView';

const router = createBrowserRouter([
  // Shared view — no Shell, no wizard nav
  { path: '/share/:code', element: <SharedView /> },

  // Main app inside Shell
  {
    path: '/',
    element: <Shell />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'projects/new', element: <NewProject /> },
      { path: 'projects/:id', element: <OpenProject /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

function App() {
  return (
    <TooltipPrimitive.Provider>
      <RouterProvider router={router} />
    </TooltipPrimitive.Provider>
  );
}

export default App;
